export default "__VITE_ASSET__Cf6mbQ6H__"